const VERIFIER_KEY = "oauth.pkce.verifier";
let pendingPkce: Promise<string> | null = null;

const base64Url = (bytes: Uint8Array): string =>
  btoa(String.fromCodePoint(...Array.from(bytes)))
    .replaceAll("+", "-")
    .replaceAll("/", "_")
    .replaceAll("=", "");

export const createPkceChallenge = async (
  verifier: string
): Promise<string> => {
  const bytes = Uint8Array.from(
    verifier,
    (character) => character.codePointAt(0) ?? 0
  );
  const digest = await globalThis.crypto.subtle.digest("SHA-256", bytes);
  return base64Url(new Uint8Array(digest));
};

const generatePkce = async (): Promise<string> => {
  sessionStorage.removeItem(VERIFIER_KEY);
  const random = globalThis.crypto.getRandomValues(new Uint8Array(32));
  const verifier = base64Url(random);
  const challenge = await createPkceChallenge(verifier);
  sessionStorage.setItem(VERIFIER_KEY, verifier);
  return challenge;
};

export const beginPkce = async (): Promise<string> => {
  pendingPkce ??= generatePkce().finally(() => {
    pendingPkce = null;
  });
  return await pendingPkce;
};

export const getPkceVerifier = (): string => {
  const verifier = sessionStorage.getItem(VERIFIER_KEY);
  if (!verifier || !/^[A-Za-z0-9_-]{43}$/.test(verifier)) {
    throw new Error("Missing or invalid PKCE verifier. Start sign-in again.");
  }
  return verifier;
};

export const clearPkce = (): void => {
  sessionStorage.removeItem(VERIFIER_KEY);
};
